import React, { Fragment } from "react";
import { PropTypes } from "prop-types";

import { Grid, Stack } from "@mui/material";
import LoadingPage from "../../../react_utils/LoadingPage";
import CustomPlot from "../../../react_utils/plots/Plot";
import DatePicker from "../../../react_utils/DatePicker";
import { LoadHistoryTitle, ProductionHistoryTitle } from "./flowhistoryutils";
import HourlyFlowDownloader from "./HourlyFlowDownloader";
import useHourlyFlow from "../../../shared/hooks/flowhistory/useHourlyFlow";
import { getColorByKey } from "../../../shared/utils/flowhistoryutils";
import LocationClient from "../../../shared/api/LocationClient";

export default function HourlyFlow({ locationClient }) {
  const { time, flow, date, flowHistory } = useHourlyFlow(locationClient);

  if (flowHistory === null) return <LoadingPage />;

  return (
    <Fragment>
      <Grid container justify="center">
        <DatePicker
          date={date.value}
          setDate={date.setValue}
          sx={{ marginBottom: "20px" }}
        />
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
        >
          <Stack direction="column" spacing={5}>
            <CustomPlot
              xlabel="Zeit"
              ylabel={"Leistung [kW]"}
              type="line"
              title={"Leistungsflüsse"}
              datasets={Object.entries(flow.power).map(([key, label]) => ({
                label,
                data: flowHistory[key].map((p, idx) => ({
                  x: time[idx],
                  y: p,
                })),
                borderColor: getColorByKey(key),
                fill: false,
                backgroundColor: getColorByKey(key, "0.8"),
                pointRadius: 0,
              }))}
              xScaleOptions={{
                type: "time",
                time: {
                  displayFormats: { hour: "HH" },
                  tooltipFormat: "dd.MM.yyyy HH:mm",
                  unit: "minute",
                },
              }}
              xTickOptions={{ stepSize: 5 }}
              stacked={false}
            />
            {Object.keys(flow.consumption).length > 0 ? (
              <CustomPlot
                xlabel="Zeit"
                ylabel={"Leistung [kW]"}
                type="line"
                title={<ProductionHistoryTitle timeHorizon="hourly" />}
                datasets={Object.entries(flow.production).map(
                  ([key, label]) => ({
                    label,
                    data: flowHistory[key].map((p, idx) => ({
                      x: time[idx],
                      y: p,
                    })),
                    borderColor: getColorByKey(key),
                    fill: true,
                    backgroundColor: getColorByKey(key, "1"),
                    pointRadius: 0,
                  }),
                )}
                xScaleOptions={{
                  type: "time",
                  time: {
                    displayFormats: { hour: "HH" },
                    tooltipFormat: "dd.MM.yyyy HH:mm",
                    unit: "minute",
                  },
                }}
                xTickOptions={{ stepSize: 5 }}
                stacked={true}
              />
            ) : null}
            {Object.keys(flow.consumption).length > 0 ? (
              <CustomPlot
                xlabel="Zeit"
                ylabel={"Leistung [kW]"}
                type="line"
                title={<LoadHistoryTitle timeHorizon="hourly" />}
                datasets={Object.entries(flow.consumption).map(
                  ([key, label]) => ({
                    label,
                    data: flowHistory[key].map((p, idx) => ({
                      x: time[idx],
                      y: p,
                    })),
                    borderColor: getColorByKey(key),
                    fill: true,
                    backgroundColor: getColorByKey(key, "1"),
                    pointRadius: 0,
                  }),
                )}
                xScaleOptions={{
                  type: "time",
                  time: {
                    displayFormats: { hour: "HH" },
                    tooltipFormat: "dd.MM.yyyy HH:mm",
                    unit: "minute",
                  },
                }}
                xTickOptions={{ stepSize: 5 }}
                stacked={true}
              />
            ) : null}

            {Object.keys(flow.batterySoc).length > 0 ? (
              <CustomPlot
                xlabel="Zeit"
                ylabel={"Ladezustand [%]"}
                type="line"
                title={"Batterie-Ladezustand"}
                datasets={Object.entries(flow.batterySoc).map(
                  ([key, label]) => ({
                    label,
                    data: flowHistory[key].map((p, idx) => ({
                      x: time[idx],
                      y: p,
                    })),
                    borderColor: getColorByKey(key),
                    fill: true,
                    backgroundColor: getColorByKey(key, "0.8"),
                    pointRadius: 0,
                  }),
                )}
                xScaleOptions={{
                  type: "time",
                  time: {
                    displayFormats: { hour: "HH" },
                    tooltipFormat: "dd.MM.yyyy HH:mm",
                    unit: "minute",
                  },
                }}
                xTickOptions={{ stepSize: 5 }}
                stacked={false}
                axRanges={{ minY: 0, maxY: 100 }}
              />
            ) : null}
          </Stack>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} sx={{ paddingY: 5 }}>
          <PieChart
            title="Nutzung der Erzeugung"
            datasets={Object.entries(flow.production).map(([key, label]) => ({
              label,
              data: flowHistory.totals[key],
              backgroundColor: getColorByKey(key, "0.8"),
              borderColor: getColorByKey(key),
            }))}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} sx={{ paddingY: 5 }}>
          <PieChart
            title="Deckung des Verbrauchs"
            datasets={Object.entries(flow.consumption).map(([key, label]) => ({
              label,
              data: flowHistory.totals[key],
              backgroundColor: getColorByKey(key, "0.8"),
              borderColor: getColorByKey(key),
            }))}
          />
        </Grid> */}
        <Grid item xs={12} sm={12} md={12} sx={{ paddingY: 10 }}>
          <HourlyFlowDownloader
            defaultDate={date.value}
            locationClient={locationClient}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

HourlyFlow.propTypes = {
  locationClient: PropTypes.instanceOf(LocationClient),
};
